import React, { useState } from "react";
import { notification, Form, Spin } from "antd";
import CustomInput from "../../components/common/Input/CustomInput";
import CustomButton from "../../components/common/button/CustomButton";
import environment from "environment";
import axios from "axios";
import VerifyToken from "./verifyToken";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RouteEnum from "constants/RouteEnum";

const LoginForm = ({ onFinish, onFinishFailed }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isVerify, setIsVerify] = useState(false);
  const [isPopup, setIsPopup] = useState(true);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [userId, setUserId] = useState();
  const { t } = useTranslation();
  const handleLogin = async (values) => {
    try {
      setLoading(true); // Set loading to true when starting the API request

      const response = await axios.post(
        `${environment.baseApi}/user/login`,
        values,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Login successful", response.data);
      const EODSTamp = await currentTimeStamp();
      const rememberMeExpirationStamp = localStorage.getItem(response.data.result.id);
      if (response.data.result.error) {
        notification.error({
          message: t('loginError'),
        });
      } else if (response.data.result.token && (localStorage.getItem(response.data.result.id)) && (rememberMeExpirationStamp > EODSTamp)) {
        notification.success({
          message: t('loginSuccess'),
        });
        setUserId(response.data.result.id);
        sessionStorage.setItem("user_id", response.data.result.id);
        sessionStorage.setItem("user_name", response.data.result.user_name);
        sessionStorage.setItem("user_email", response.data.result.email);
        sessionStorage.setItem("authToken", response.data.result.token);

        navigate(RouteEnum.Extractpdf);
      } else {
        setIsVerify(true);
        setQrCodeUrl(response.data.result.qrCodeImageUrl);
        setUserId(response.data.result.id);
        sessionStorage.setItem("user_id", response.data.result.id);
        sessionStorage.setItem("user_name", response.data.result.user_name);
        sessionStorage.setItem("user_email", response.data.result.email);
      }
    } catch (error) {
      console.error("Login failed", error);
      notification.error({
        message: "Login Error",
        description: error,
      });
    } finally {
      setLoading(false);
    }
  };

  const currentTimeStamp = async () => {
    const currentDate = new Date();
    const EODTimestamp = currentDate.getTime()
    return EODTimestamp
  }
  const toggleLoginForm = () => {
    setIsPopup(true);
    setIsVerify(false);
  };

  return (
    <Spin spinning={loading} tip="Loading..." size="large">
      <div
        className="login-form-container"
        style={{ maxWidth: "600px", margin: "0 auto" }}
      >
        {isPopup && isVerify ? (
          <VerifyToken
            qrCodeUrl={qrCodeUrl}
            user={userId}
            toggleLoginForm={toggleLoginForm}
          />
        ) : (
          <Form
            name="login"
            labelCol={{ span: 0 }}
            wrapperCol={{ span: 45 }}
            onFinish={handleLogin}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div className="mt-4 pt-2 login-inputs mail-icon">
              <label className="form-label">Email</label>
              <CustomInput
                addon="mail"
                name="email"
                type="text"
                className="br30"
                placeholder={t("enterEmail")}
                rules={[
                  {
                    type: "email",
                    message: t("invalidEmail"),
                  },
                  {
                    required: true,
                    message: t("emailEmpty"),
                  },
                ]}
              />
            </div>
            <div className="mt-0 login-inputs lock-icon">
              <label className="form-label">{t("password")}</label>
              <CustomInput
                addon="lock"
                name="password"
                type="password"
                placeholder={t("password")}
                className="mb-1 br30 login-password-icon"
                rules={[
                  {
                    required: true,
                    message: t("passwordEmpty"),
                  },
                ]}
              />
            </div>
            <div className="d-flex justify-content-between mb-3">
              <div className="form-check">
                {/*<input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                <label className="form-check-label link-info" for="flexCheckDefault">
                  {t("loginRemember")}
                </label>*/}
              </div>
              <div className="">
                <a href="" className="link-text">{t("ForgotPassword")}</a>
              </div>
            </div>
            <div>
              <CustomButton
                label={t("loginOrSignup")}
                type="primary"
                htmlType="submit"
                className="btn-blue font-color w-100 br8 h44"
                navigate={false}
                span_className="poppins-semibold fs16"
              />
            </div>
            <div className="d-flex justify-content-center">
             <span className="link-info">{t("NoAccount")}</span>
             <a href="" className="link-text ms-1">{t("signUp")}</a>
            </div>
          </Form>
        )}
      </div>
    </Spin>
  );
};

export default LoginForm;
